import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-user-attachments-info-panel',
  templateUrl: './user-attachments-info-panel.component.html',
  styleUrls: ['./user-attachments-info-panel.component.scss']
})
export class UserAttachmentsInfoPanelComponent implements OnInit {
  @Input() user: User;
  constructor() { }

  ngOnInit() {
  }

}
